import { Box, DialogContent, DialogTitle, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FIRM_DOCUMENT_PREVIEW_PANEL_TEST_IDS } from 'pages/Documents/FirmDocuments/components/FirmDocumentPreviewPanel/FirmDocumentPreviewPanel.testIds';

export const BrowseDocumentsDialogTitle = styled(DialogTitle)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1.5),
  paddingRight: theme.spacing(6),
}));

export const BrowseDocumentsTitleText = styled(Box)({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  minWidth: 0,
});

export const BrowseDocumentsSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const BrowseDocumentsDialogContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
  height: '85vh',
  minHeight: 0,
  overflow: 'hidden',
  padding: 0,
});

export const BrowseDocumentsBody = styled(Box)({
  display: 'flex',
  flex: '1 1 auto',
  minHeight: 0,
  minWidth: 0,
});

export const BrowseDocumentsListPane = styled(Box)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flex: '0 0 380px',
  flexDirection: 'column',
  maxWidth: '40%',
  minHeight: 0,
  minWidth: 280,
  overflow: 'auto',
}));

export const BrowseDocumentsPreviewPane = styled(Box, {
  shouldForwardProp: prop => prop !== 'isExpanded',
})<{ isExpanded?: boolean }>(({ isExpanded }) => ({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  minHeight: 0,
  minWidth: 0,
  // Keep FirmDocumentPreviewPanel in-flow when "expanded" inside this dialog
  // rather than escaping to a viewport-fixed overlay behind the dialog paper.
  ...(isExpanded
    ? {
      [`& [data-testid="${FIRM_DOCUMENT_PREVIEW_PANEL_TEST_IDS.root}"]`]: {
        height: '100%',
        inset: 'unset',
        maxHeight: '100%',
        position: 'relative',
        width: '100%',
        zIndex: 'auto',
      },
    }
    : {}),
}));

export const BrowseDocumentsEmptyPreview = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.text.secondary,
  display: 'flex',
  flex: '1 1 auto',
  justifyContent: 'center',
  minHeight: 0,
  padding: theme.spacing(3),
  textAlign: 'center',
}));
